
import "./button"; // registers <leaselink-button>
import { LeaseLinkWidget } from "./widget-core";
import { Config } from "./types";

// The shortcode loads this bundle only for <widget-leaselink-button>, without
// a widget config — registering the element is then all that is needed.
const config = (window as any).leaseLinkWidgetConfig as Config | undefined;

if (config) {
  (window as any).leaseLinkWidget = new LeaseLinkWidget(config);
}
